import React from "react"

export function MyPage() {
    return (<></>)
}